import { Element } from '../../../../common/html/element'

const CustomizedLabelLine = (props) => {
  const { x, y, value, style, formatValue } = props

  return (
    <g>
      <foreignObject x={x - 25} y={y - 20} height={18} width={50}>
        <Element
          className="h100 w100 textCenter fw400"
          style={{ fontSize: 10, color: '#3A414B', ...(style || {}) }}
        >
          {formatValue ? formatValue(value) : Math.round(value) + '%'}
        </Element>
      </foreignObject>
    </g>
  )
}

export default CustomizedLabelLine
